<template>
  <div style="background-color: #fcfcfc; min-height: 100vh; height: auto">
    <NavbarNew></NavbarNew>
    <div class="container-fluid" style="padding-top: 70px; padding-left: 40px">
      <div class="row w-100 ml-0 mr-0">
        <div class="profileSettingsTitle">Profile Settings</div>
      </div>
      <div
        class="row w-100 ml-0 mr-0"
        style="margin-top: 30px; margin-bottom: 50px"
      >
        <div
          class="col-2 pl-0 pr-0"
          style="
            cursor: pointer;
            border-right: 1px solid rgba(0, 0, 0, 0.2);
            min-height: 80vh;
            height: auto;
          "
        >
          <div
            @click="
              showUserInfo = true;
              showEmailPreferences = false;
              showHelp = false;
            "
            :style="
              showUserInfo
                ? 'border-right:2px solid #593BFD;margin-bottom: 20px;margin-top:20px'
                : 'margin-bottom: 20px;margin-top:20px'
            "
          >
            <div class="d-flex">
              <div>
                <img :src="getUrl('userInfo')" />
              </div>
              <div
                class="d-flex align-items-center"
                style="margin-left: 10px; height: 30px"
              >
                <div
                  class="profileSettingsSideBarTabText"
                  :style="showUserInfo ? 'color:#593BFD;' : ''"
                >
                  User Info
                </div>
              </div>
            </div>
          </div>
          <div
            @click="
              showUserInfo = false;
              showEmailPreferences = true;
              showHelp = false;
            "
            :style="
              showEmailPreferences
                ? 'border-right:2px solid #593BFD;margin-bottom: 20px'
                : 'margin-bottom: 20px'
            "
          >
            <div class="d-flex">
              <div>
                <img :src="getUrl('emailPreferences')" />
              </div>
              <div
                class="d-flex align-items-center"
                style="margin-left: 10px; height: 30px"
              >
                <div
                  class="profileSettingsSideBarTabText"
                  :style="showEmailPreferences ? 'color:#593BFD;' : ''"
                >
                  Email Preferences
                </div>
              </div>
            </div>
          </div>
          <div
            @click="
              showUserInfo = false;
              showEmailPreferences = false;
              showHelp = true;
            "
            :style="showHelp ? 'border-right:2px solid #593BFD;' : ''"
          >
            <div class="d-flex">
              <div>
                <img :src="getUrl('help')" />
              </div>
              <div
                class="d-flex align-items-center"
                style="margin-left: 10px; height: 30px"
              >
                <div
                  class="profileSettingsSideBarTabText"
                  :style="showHelp ? 'color:#593BFD;' : ''"
                >
                  Help
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10" style="padding-left: 30px">
          <div v-if="showUserInfo">
            <div class="row ml-0 mr-0 w-100" style="margin-bottom: 40px">
              <div class="d-flex">
                <div>
                  <div class="d-flex justify-content-center">
                    <div
                      class="accountProfileEditIconOuterLayout"
                      style="cursor: pointer"
                      @click="$refs.workspaceProfileLogo.click()"
                    >
                      <div class="workspaceProfileLogoEditIconLayout">
                        <div class="workspaceProfileLogoEditIconInnerLayout">
                          <i class="fas fa-pencil-alt"></i>
                          <input
                            type="file"
                            ref="workspaceProfileLogo"
                            @change="handleFile"
                            class="hidden"
                            accept="image/*"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="workspaceProfileLogo">
                    <b-avatar
                      :text="avatarText"
                      class="align-baseline profileAvatar"
                      :style="`background:${backgroundColor};min-width:100%;min-height:100%;border-radius:50%;`"
                      :src="avatarLogo"
                    ></b-avatar>
                  </div>
                </div>
                <div style="margin-left: 50px">
                  <div class="d-flex align-items-center" style="height: 204px">
                    <div>
                      <div class="d-flex my-auto">
                        <div class="accountProfileName">
                          {{
                            `${this.user.firstName} ${
                              this.user.lastName != undefined
                                ? this.user.lastName
                                : ""
                            }`
                          }}
                        </div>
                      </div>
                      <div class="d-flex my-auto">
                        <div class="accountProfileEmail">{{ getEmail }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row ml-0 mr-0 w-100">
              <div class="col-10 pl-0 pr-0">
                <form @submit.prevent="saveProfile">
                  <div class="row">
                    <div class="col-4">
                      <label>First Name</label>
                      <input
                        type="text"
                        required
                        v-model="userProfile.firstName"
                        @keyup="saveProfilekeyUp"
                        class="form-control"
                        placeholder="First Name"
                      />
                    </div>
                    <!--  @keyup="updateCheck=true" -->
                    <div class="col-4">
                      <label>Last Name</label>
                      <input
                        type="text"
                        required
                        class="form-control"
                        v-model="userProfile.lastName"
                        @keyup="saveProfilekeyUp"
                        placeholder="Last Name"
                      />
                    </div>
                    <div
                      v-if="userProfile.cognito && userProfile.cognito.id"
                      class="col-4"
                    >
                      <label>Email</label>
                      <input
                        type="email"
                        class="form-control"
                        required
                        @keyup="
                          updateCheck =
                            userProfile.firstName &&
                            userProfile.firstName.length > 0 &&
                            userProfile.lastName &&
                            userProfile.lastName.length > 0 &&
                            userProfile.cognito.email &&
                            userProfile.cognito.email.length > 0 &&
                            validateEmail(userProfile.cognito.email)
                              ? true
                              : false
                        "
                        v-model="userProfile.cognito.email"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div slot="footer" class="dialog-footer" style>
                    <div
                      class="col-xl edit-company-action-button-row"
                      style="padding: 0px; margin-top: 20px"
                    >
                      <button
                        type="submit"
                        class="todo-form-submit-button btn btn-primary"
                        :disabled="submitted || !updateCheck"
                        style="margin-right: 0px; margin-bottom: 0px"
                      >
                        Save
                        <b-spinner
                          v-if="submitted"
                          style="float: right"
                          small
                          label="Loading..."
                        ></b-spinner>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div style="margin-top: 30px">
              <div class="row ml-0 mr-0 w-100" style="margin-bottom: 15px">
                <div class="accountProfileUserInfoTitles">Single Sign On</div>
              </div>
              <div class="row ml-0 mr-0 w-100">
                <div class="col-10 pl-0 pr-0">
                  <div class="row ml-0 mr-0 w-100">
                    <div class="col-4 pl-0">
                      <div class="ssoLinksOuterLayout">
                        <div style="padding: 10px 10px 10px 15px">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <div class="d-flex">
                                <div style="margin-right: 10px">
                                  <div class="ssoLinkImagesLayout">
                                    <img
                                      src="static/img/link-icon.png"
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                </div>
                                <div
                                  :class="checkSso('linkedin') ? 'd-flex' : ''"
                                >
                                  <div
                                    class="ssoEmails"
                                    v-if="
                                      user.linkedin &&
                                      user.linkedin.id &&
                                      user.linkedin.email
                                    "
                                  >
                                    {{ user.linkedin.email }}
                                  </div>
                                  <div
                                    style="
                                      cursor: pointer;
                                      font-size: 14px;
                                      line-height: 16px;
                                    "
                                    @click="Link('linkedin', linkedin)"
                                    :class="
                                      user.linkedin && user.linkedin.id
                                        ? 'text-danger d-flex my-auto'
                                        : 'text-info d-flex my-auto'
                                    "
                                  >
                                    {{
                                      user.linkedin && user.linkedin.id
                                        ? "Unlink"
                                        : "Link"
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="user.linkedin && user.linkedin.id">
                              <div style="color: #28b446">
                                <i class="fas fa-check"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="ssoLinksOuterLayout">
                        <div style="padding: 10px 10px 10px 15px">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <div class="d-flex">
                                <div style="margin-right: 10px">
                                  <div class="ssoLinkImagesLayout">
                                    <img
                                      src="static/img/google-icon.png"
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                </div>
                                <div
                                  :class="checkSso('google') ? 'd-flex' : ''"
                                >
                                  <div
                                    class="ssoEmails"
                                    v-if="
                                      user.google &&
                                      user.google.id &&
                                      user.google.email
                                    "
                                  >
                                    {{ user.google.email }}
                                  </div>
                                  <div
                                    style="
                                      cursor: pointer;
                                      font-size: 14px;
                                      line-height: 16px;
                                    "
                                    @click="Link('google', google)"
                                    :class="
                                      user.google && user.google.id
                                        ? 'text-danger d-flex my-auto'
                                        : 'text-info d-flex my-auto'
                                    "
                                  >
                                    {{
                                      user.google && user.google.id
                                        ? "Unlink"
                                        : "Link"
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="user.google && user.google.id">
                              <div style="color: #28b446">
                                <i class="fas fa-check"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 pr-0">
                      <div class="ssoLinksOuterLayout">
                        <div style="padding: 10px 10px 10px 15px">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <div class="d-flex">
                                <div style="margin-right: 10px">
                                  <div class="ssoLinkImagesLayout">
                                    <img
                                      src="static/img/twitter-icon.png"
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                </div>
                                <div
                                  style="
                                    cursor: pointer;
                                    font-size: 14px;
                                    line-height: 16px;
                                  "
                                  @click="Link('twitter', twitter)"
                                  :class="
                                    user.twitter && user.twitter.id
                                      ? 'text-danger d-flex my-auto'
                                      : 'text-info d-flex my-auto'
                                  "
                                >
                                  {{
                                    user.twitter && user.twitter.id
                                      ? "Unlink"
                                      : "Link"
                                  }}
                                </div>
                              </div>
                            </div>
                            <div v-if="user.twitter && user.twitter.id">
                              <div style="color: #28b446">
                                <i class="fas fa-check"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="margin-top: 30px"
              v-if="userProfile.cognito && userProfile.cognito.id"
            >
              <div class="row ml-0 mr-0 w-100" style="margin-bottom: 15px">
                <div class="accountProfileUserInfoTitles">Reset Password</div>
              </div>
              <div class="row ml-0 mr-0 w-100">
                <div class="col-10 pl-0 pr-0">
                  <form @submit.prevent="changePswd">
                    <div class="row ml-0 mr-0 w-100">
                      <div class="col-4 pl-0">
                        <label>Old Password</label>
                        <input
                          type="password"
                          class="form-control team-form"
                          v-model="pswd.oldPswd"
                          required
                          placeholder="Old Password"
                        />
                      </div>
                      <div class="col-4">
                        <label>New Password</label>
                        <input
                          type="password"
                          v-model="pswd.newPswd"
                          class="form-control team-form"
                          required
                          @keyup="passwordValidation"
                          placeholder="New Password"
                        />
                      </div>
                      <div class="col-4 pr-0">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          v-model="pswd.cnfrmPswd"
                          required
                          class="form-control team-form"
                          placeholder="Confirm Password"
                        />
                      </div>
                    </div>
                    <small class="text-danger" v-if="!valid"
                      >Password must be minimum of 8 characters, it should be
                      alphanumeric and have at least one uppercase and one
                      special character.</small
                    >
                    <div slot="footer" class="dialog-footer" style>
                      <div
                        class="col-xl edit-company-action-button-row"
                        style="padding: 0px; margin-top: 20px"
                      >
                        <button
                          type="submit"
                          :disabled="passwordSubmitted || !valid"
                          class="todo-form-submit-button btn btn-primary"
                          style="margin-right: 0px"
                        >
                          Save
                          <b-spinner
                            v-if="passwordSubmitted"
                            style="float: right"
                            small
                            label="Loading..."
                          ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px">
              <div class="row ml-0 mr-0 w-100">
                <div class="col-10 pl-0 pr-0">
                  <div class="clearDataOuterLayout">
                    <div class="row ml-0 mr-0 w-100" style="padding: 20px">
                      <div class="col-10 pl-0 pr-0">
                        Clear My Data permanently deletes all the workspaces and
                        its data associated with this account.
                      </div>
                      <div class="col-2 pl-0 pr-0">
                        <button
                          class="ml-2 btn-fill btn-wd main-secondary-button"
                          @click="deleteFlag = true"
                        >
                          Clear My Data
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showEmailPreferences" style="margin-top: 10px">
            <div class="row ml-0 mr-0" style="margin-bottom: 30px">
              <div>
                Help us improve your experience with fiifi though communication.
                Please adjust your email preferences below and we will refine
                our messages to you accordingly.
              </div>
            </div>
            <div class="row" style="margin: 1px 1px 20px 1px">
              <div style="margin-right: 10px">
                <input
                  type="checkbox"
                  id="dailyCheckbox"
                  v-model="dailyCheckbox"
                  class="regular-checkbox"
                  style="cursor: pointer"
                  @change="checkBoxChangeEvent($event)"
                />
              </div>
              <div>
                <div class="emailPreferencesCheckBoxesText">
                  Daily Email update
                </div>
                <div
                  class="emailPreferencesCheckBoxesSubText"
                  style="margin-top: 5px"
                >
                  Important news updates on your portfolio, timely
                  notifications, team updates, and pending tasks.
                </div>
              </div>
            </div>
            <div class="row" style="margin: 1px 1px 20px 1px">
              <div style="margin-right: 10px">
                <input
                  type="checkbox"
                  id="weeklyCheckbox"
                  v-model="weeklyCheckbox"
                  class="regular-checkbox"
                  style="cursor: pointer"
                  @change="checkBoxChangeEvent($event)"
                />
              </div>
              <div>
                <div class="emailPreferencesCheckBoxesText">
                  Weekly progress reports
                </div>
                <div
                  class="emailPreferencesCheckBoxesSubText"
                  style="margin-top: 5px"
                >
                  Get a weekly report with statistics and insights on workspace
                  activity.
                </div>
              </div>
            </div>
            <div class="row" style="margin: 1px 1px 20px 1px">
              <div style="margin-right: 10px">
                <input
                  type="checkbox"
                  id="monthlyCheckbox"
                  v-model="monthlyCheckbox"
                  class="regular-checkbox"
                  style="cursor: pointer"
                  @change="checkBoxChangeEvent($event)"
                />
              </div>
              <div>
                <div class="emailPreferencesCheckBoxesText">Monthly recap</div>
                <div
                  class="emailPreferencesCheckBoxesSubText"
                  style="margin-top: 5px"
                >
                  Monthly update on overall progress of your portfolio.
                </div>
              </div>
            </div>
            <div class="row ml-0 mr-0" style="margin-top: 30px">
              <div>
                By unchecking all boxes you will be unsubscribed from our
                emails. You will still receive important transactional and
                billing related emails.
              </div>
            </div>
          </div>
          <div v-if="showHelp" style="margin-top: 10px">
            <p>
              Congratulations! You have instant access to fiifi, start using
              this software and give us feedback as it develops.
            </p>
            <p>
              <b>Note : </b> You have been granted early access, this product is
              not complete and will change further. If you are not excited to
              use fiifi in its current state, then please wait until the
              software progresses further in development to use
            </p>
            <p>
              Fiifi is already a robust tool for early stage investors, filled
              with features needed to make early stage investments, a registrar,
              charts, graphs and data for you to make more informed decisions.
            </p>
            <p>
              We designed fiifi for early access from the ground up, so you
              could help us make it even better by our first beta version
              launch.
            </p>
            <p>
              We are here to help! If you have questions, comments and
              especially feedback we would love to hear it.
            </p>
            <p>
              Please reach out to
              <a href="mailto: support@fiifi.co">support@fiifi.co</a>
            </p>
            <p>
              <b>Referrals :</b>
              <a href="mailto: founders@fiifi.co" style="padding-left: 3px"
                >founders@fiifi.co</a
              >
            </p>
            <div style="margin-top: 30px">
              <div
                class="w-100"
                style="border-top: 2px solid rgba(0, 0, 0, 0.2)"
              >
                <div style="margin-top: 30px">Our Channel</div>
                <div
                  style="
                    height: 122px;
                    width: 218px;
                    margin-top: 15px;
                    cursor: pointer;
                  "
                >
                  <a
                    target="_blank"
                    href="https://www.youtube.com/channel/UCufif1B3s14V9_1krM7JGKQ/videos"
                  >
                    <img
                      src="static/img/fiifiYoutubeChannel.png"
                      width="100%"
                      height="100%"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      left
      title
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="300px"
      style="margin: 0 auto"
      :visible.sync="showLoader"
      class="loadingModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div style="text-align: center">
        <div>
          <b-spinner
            style="width: 7rem; height: 7rem; color: #5445f3"
            class="mt-5"
            label="Large Spinner"
          ></b-spinner>
        </div>
        <div style="margin-top: 15px; color: #000">Loading...</div>
      </div>
    </el-dialog>
    <el-dialog
      center
      width="400px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="deleteFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="margin-left: auto; margin-right: auto">
          Are you sure you want to continue?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDelete"
            :disabled="isDisabled"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="clearUser"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="isDisabled"
          >
            Continue
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import { Dialog } from "element-ui";
import { pickBackgroundColor } from "../../../util/index";
import config from "../../../../config/settings";
export default {
  name: "profileSetting",
  components: {
    NavbarNew,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      showUserInfo: false,
      showEmailPreferences: false,
      showHelp: false,
      dailyCheckbox: false,
      weeklyCheckbox: false,
      monthlyCheckbox: false,
      showLoader: false,
      userProfile: {},
      invite: {},
      valid: false,
      submitted: false,
      passwordSubmitted: false,
      currentRoleId: "",
      facebook: false,
      twitter: false,
      google: false,
      linkedin: false,
      updateCheck: false,
      userProfile: {},
      inviteForm: {},
      pswd: {},
      type: "",
      variant: "",
      navLink: "account",
      message: "",
      roles: ["Admin", "Manager", "collaborator"],
      deleteFlag: false,
      isDisabled: false,
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    account_role() {
      return this.$store.getters["role/account_role"];
    },
    current_role() {
      return this.$store.getters["role/current_role"];
    },
    avatarLogo() {
      let logo = "";
      if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("image") &&
        this.userProfile.image.length > 0
      ) {
        logo = this.userProfile.image;
      }
      this.showLoader = false;
      return logo;
    },
    avatarText() {
      if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("firstName") &&
        this.userProfile.firstName.length > 0
      ) {
        let text = this.userProfile.firstName.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)}${text[1].charAt(0)}`
            : text[0].charAt(0);

        return text;
      } else {
        return "U";
      }
    },
    backgroundColor() {
      if (this.avatarLogo && this.avatarLogo.length > 0) {
        return "";
      } else {
        return this.pickBackgroundColor(this.avatarText);
      }
    },
    getEmail() {
      let email = "";
      if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("cognito") &&
        this.userProfile.cognito.hasOwnProperty("email") &&
        this.userProfile.cognito.email &&
        this.userProfile.cognito.email.length > 0
      ) {
        email = this.userProfile.cognito.email;
      } else if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("google") &&
        this.userProfile.google.hasOwnProperty("email") &&
        this.userProfile.google.email &&
        this.userProfile.google.email.length > 0
      ) {
        email = this.userProfile.google.email;
      } else if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("linkedin") &&
        this.userProfile.linkedin.hasOwnProperty("email") &&
        this.userProfile.linkedin.email &&
        this.userProfile.linkedin.email.length > 0
      ) {
        email = this.userProfile.linkedin.email;
      } else if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("twitter") &&
        this.userProfile.twitter.hasOwnProperty("email") &&
        this.userProfile.twitter.email &&
        this.userProfile.twitter.email.length > 0
      ) {
        email = this.userProfile.twitter.email;
      } else if (
        this.userProfile &&
        this.userProfile.hasOwnProperty("ltse") &&
        this.userProfile.ltse.hasOwnProperty("email") &&
        this.userProfile.ltse.email &&
        this.userProfile.ltse.email.length > 0
      ) {
        email = this.userProfile.ltse.email;
      }
      return email;
    },
  },
  methods: {
    pickBackgroundColor: pickBackgroundColor,
    getUrl(context) {
      if (context == "emailPreferences") {
        return this.showEmailPreferences
          ? "static/img/profileSettingsActiveEmailPreferences.svg"
          : "static/img/profileSettingsEmailPreferences.svg";
      }
      if (context == "userInfo") {
        return this.showUserInfo
          ? "static/img/profileSettingsActiveUserInfo.svg"
          : "static/img/profileSettingsUserInfo.svg";
      }
      if (context == "help") {
        return this.showHelp
          ? "static/img/profileSettingsActiveHelp.svg"
          : "static/img/profileSettingsHelp.svg";
      }
    },
    checkBoxChangeEvent(e) {
      const self = this;
      api
        .patch(`/emailPreferences/${self.$route.params.account_id}`, {
          encrypt: {
            data: {
              isDailySubscribed: self.dailyCheckbox,
              isweeklySubscribed: self.weeklyCheckbox,
              isMonthlySubscribed: self.monthlyCheckbox,
            },
          },
        })
        .then((data) => {
          self.$toaster.success("Email Preferences updated successfully.");
        })
        .catch((error) => {
          console.log("error in updating emailPreferences", error);
        });
    },
    getEmailPreferences() {
      api
        .get(`/emailPreferences/${this.$route.params.account_id}`, {})
        .then((data) => {
          let emailPreferencesData = data.data.encrypt.success;
          if (emailPreferencesData.length > 0) {
            this.dailyCheckbox = emailPreferencesData[0].isDailySubscribed
              ? emailPreferencesData[0].isDailySubscribed
              : false;
            this.weeklyCheckbox = emailPreferencesData[0].isweeklySubscribed
              ? emailPreferencesData[0].isweeklySubscribed
              : false;
            this.monthlyCheckbox = emailPreferencesData[0].isMonthlySubscribed
              ? emailPreferencesData[0].isMonthlySubscribed
              : false;
          }
        })
        .catch((error) => {
          console.log("error in getting emailPreferences", error);
        });
    },
    checkSwitch(data) {
      if (data.google && data.google._id) this.google = true;
      if (data.facebook && data.facebook._id) this.facebook = true;
      if (data.twitter && data.twitter._id) this.twitter = true;
      if (data.linkedin && data.linkedin._id) this.linkedin = true;
    },
    handleFile(e) {
      const self = this;
      let image = event.target.files[0];
      if (!image) return;
      this.showLoader = true;
      let imageType = image.type && image.type.length > 0 ? image.type : "";
      let imageValidation =
        imageType.length > 0 &&
        (imageType == "image/jpeg" ||
          imageType == "image/png" ||
          imageType == "image/gif" ||
          imageType == "image/jpg" ||
          imageType == "image/svg" ||
          imageType == "image/svg+xml")
          ? true
          : false;
      if (!imageValidation) {
        this.showLoader = false;
        this.$toaster.error(
          `File not supported. We only support jpeg, jpg, png, svg and gif images.`
        );
        return;
      }
      let filePayload = {
        files: [],
        data: [],
      };
      filePayload.files.push(image);
      filePayload.data.push({
        account: this.$route.params.account_id,
        image:
          this.userProfile &&
          this.userProfile.hasOwnProperty("image") &&
          this.userProfile.image.length > 0
            ? this.userProfile.image
            : "",
        key:
          this.userProfile &&
          this.userProfile.hasOwnProperty("s3Key") &&
          this.userProfile.s3Key.length > 0
            ? this.userProfile.s3Key
            : "",
      });
      this.$store
        .dispatch("user/apiPostAccountImage", filePayload)
        .then((data) => {
          this.userProfile = data.data.encrypt.success[0];
          this.$store.commit("user/image", { image: this.userProfile.image });
          this.$store.commit("user/s3Key", { s3Key: this.userProfile.s3Key });
          let fiifiUsers = JSON.parse(window.localStorage.fiifiUsers);
          fiifiUsers.map((item) => {
            if (item._id == this.userProfile._id) {
              item.image = this.userProfile.image;
              item.s3Key = this.userProfile.s3Key;
            }
          });
          window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
          this.$toaster.success("Successfully saved.");
          this.showLoader = false;
        })
        .catch((error) => {
          console.log("error during account profile upload", error);
          this.$toaster.error(
            "Something went wrong. Please try again after some time"
          );
          this.showLoader = false;
        });
    },
    saveProfilekeyUp() {
      this.updateCheck =
        this.userProfile &&
        this.userProfile.firstName &&
        this.userProfile.firstName.length > 0 &&
        this.userProfile.lastName &&
        this.userProfile.lastName.length > 0
          ? true
          : false;
    },
    saveProfile(e) {
      e.preventDefault();
      this.submitted = true;
      if (this.userProfile.cognito && this.userProfile.cognito.user_name) {
        this.userProfile.email = this.userProfile.cognito.email;
        this.userProfile.user_name = this.userProfile.cognito.user_name;
      }
      api
        .patch("/user/profile", { encrypt: { data: this.userProfile } })
        .then((res) => {
          let user = res.data.encrypt.success;
          this.updateCheck = false;
          this.$store.commit("user/first_name", { first_name: user.firstName });
          this.$store.commit("user/last_name", { last_name: user.lastName });
          let fiifiUsers = JSON.parse(window.localStorage.fiifiUsers);
          fiifiUsers.map((item) => {
            if (item._id == user._id) {
              item.firstName = user.firstName;
              item.lastName = user.lastName;
              if (user.cognito && user.cognito.user_name) {
                item.email = user.cognito.email;
                this.$store.commit("user/email", { email: user.cognito.email });
                this.$store.commit("user/cognito", { cognito: user.cognito });
              }
            }
          });
          window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
          this.$toaster.success("Successfully saved.");
          this.submitted = false;
        })
        .catch((err) => {
          this.variant = "danger";
          this.submitted = false;
          this.$toaster.error("Fail to update user information");
        });
    },
    Link(type, check) {
      this.type = type;
      if (type == "linkedin") {
        if (this.user.linkedin && this.user.linkedin.id) {
          this.updateUser("/linkedin/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/linkedin`;
        }
      } else if (type == "google") {
        if (this.user.google && this.user.google.id) {
          this.updateUser("/google/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/google`;
        }
      } else if (type == "facebook") {
        if (this.user.facebook && this.user.facebook.id) {
          this.updateUser("/facebook/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/facebook`;
        }
      } else if (type == "twitter") {
        if (this.user.twitter && this.user.twitter.id) {
          this.updateUser("/twitter/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/twitter`;
        }
      }
    },
    updateUser(url, user) {
      if (!user) {
        let a = Object.values(this.user);
        let count = 0;
        for (let obj of a) if (typeof obj == "object" && obj["id"]) count++;
        if (count == 1) {
          alert("You cannot unlink your primary account");
          return;
        }
      }
      // this.$notify({ component: NotificationSample, timeout: 3000 });
      let payload = {};
      if (user) payload = user;
      else payload = null;
      api
        .put(url, { encrypt: { data: payload } })
        .then((data) => {
          let user = data.data.encrypt.success;
          if ((payload == null) & (this.type.length > 0)) user[this.type] = {};
          this.setStoreUser(user);
        })
        .catch((err) => {
          alert(err.response.data.message);
          this.$router.push(`/${this.$route.params.account_id}/profile`);
        });
    },
    setStoreUser(user) {
      if (user.google)
        this.$store.commit("user/google", { google: user.google });
      if (user.facebook)
        this.$store.commit("user/facebook", { facebook: user.facebook });
      if (user.twitter)
        this.$store.commit("user/twitter", { twitter: user.twitter });
      if (user.linkedin)
        this.$store.commit("user/linkedin", { linkedin: user.linkedin });
      this.$router.push(`/${this.$route.params.account_id}/profile`);
    },
    passwordValidation() {
      let data = this.checkPassword(this.pswd.newPswd);
      if (data) this.valid = true;
      else this.valid = false;
    },
    checkPassword(str) {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
    },
    changePswd(e) {
      e.preventDefault();
      if (this.pswd.newPswd == this.pswd.cnfrmPswd) {
        this.passwordSubmitted = true;
        this.$Amplify.Auth.currentAuthenticatedUser()
          .then((user) => {
            console.log(user);
            this.$Amplify.Auth.changePassword(
              user,
              this.pswd.oldPswd,
              this.pswd.newPswd
            )
              .then((response) => {
                this.$toaster.success(
                  "Password has been changed successfully."
                );
                this.passwordSubmitted = false;
                this.$router.push("/login");
              })
              .catch((error) => {
                this.variant = "danger";
                this.$toaster.error("Please enter valid Password.");
                // this.$router.push("/login");
                this.passwordSubmitted = false;
              });
          })
          .catch((err) => {
            this.variant = "danger";
            this.$toaster.error("Unable to process your request.");
            this.$router.push("/login");
            this.passwordSubmitted = false;
          });
      } else {
        this.variant = "danger";
        this.$toaster.error("Password does not match..!");
      }
    },
    userCleared() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.$store.commit("user/initialize");
      this.$store.commit("portfolio/initialize");
      this.$store.commit("role/initialize");
      this.$store.commit("team/initialize");
      this.$store.commit("investment/initialize");
      this.$store.commit("offering/initialize");
      this.$store.commit("todo/initialize");
      this.$store.commit("file/initialize");
      this.$store.commit("workspace/initialize");
      this.$store.commit("diligence/initialize");
      this.$store.commit("diligence_stage/initialize");
      this.$store.commit("transaction_type/initialize");
      this.$store.commit("newsFeed/initialize");
      this.$store.commit("suggestions/initialize");
      this.$store.commit("workspacePlans/initialize");
      this.$store.commit("accountPlans/initialize");
      this.$store.commit("contacts/initialize");
      this.$store.commit("lpAllocations/initialize");
      this.$store.commit("dashboardCoordinates/initialize");
      this.$store.commit("rounds/initialize");
      this.$router.push("#/login");
    },
    clearUser(e) {
      e.preventDefault();
      this.submitted = true;
      this.showSpinner = true;
      this.isDisabled = true;
      this.$store
        .dispatch("user/apiDeleteUser")
        .then((res) => {
          // alert
          this.submitted = false;
          this.handleCancelDelete();
          alert("Successfully removed your data from the server!");
          this.userCleared();
        })
        .catch((err) => {
          // alert('Unable to delete your info at this time (see console for more detail).')
          console.error(`Error deleting user: ${JSON.stringify(err)}`);
          this.userCleared();
        });
    },
    handleCancelDelete() {
      this.deleteFlag = false;
      this.isDisabled = false;
      this.showSpinner = false;
    },
    checkSso(context) {
      return this.user &&
        this.user.hasOwnProperty(context) &&
        (!this.user[context] || !this.user[context]._id)
        ? true
        : false;
    },
    validateEmail(emailField) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (reg.test(emailField) == false) {
        // this.$toaster.error("Invalid Email Address");
        return false;
      }

      return true;
    },
  },
  mounted() {
    this.$store.commit("todo/setCurrentComponent", "dashboard");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Profile`;
    this.showUserInfo = true;
    this.currentRoleId = this.current_role ? this.current_role._id : false;
    this.checkSwitch(this.user);
    this.userProfile = JSON.parse(JSON.stringify(this.user));
    // this.userProfile.image =
    //   this.userProfile.image && this.userProfile.image.length > 0
    //     ? this.userProfile.image
    //     : "static/img/Profile.png";
    if (this.$route.params.account_id) {
      this.getEmailPreferences();
    }
    if (this.$route.query.user) {
      if (this.$route.query.type == "google") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/google/update/profile", user);
      }
      if (this.$route.query.type == "facebook") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/facebook/update/profile", user);
      }
      if (this.$route.query.type == "twitter") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/twitter/update/profile", user);
      }
      if (this.$route.query.type == "linkedin") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/linkedin/update/profile", user);
      }
      this.$router.push(`/${this.$route.params.account_id}/profile`);
    }
    this.$watch(
      () => {
        return this.user;
      },
      (data) => {
        this.checkSwitch(data);
      }
    );
  },
};
</script>
<style>
.accountProfileEditIconOuterLayout {
  position: absolute;
  z-index: 1;
  top: 160px;
  left: 176px;
}

.ssoLinksOuterLayout {
  height: 55px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001a;
  border-radius: 4px;
  opacity: 1;
}

.ssoLinkImagesLayout {
  height: 35px;
  width: 35px;
}

.clearDataOuterLayout {
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  opacity: 1;
}
</style>